/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import { createRouter, createWebHistory } from 'vue-router';
import system from '@/views/System/Admin.vue';
// import HomeView from '../views/HomeView.vue';
import { routeState } from './routeState';

const routes = [
  {
    // 登入頁
    path: '/login',
    name: 'login',
    component: () => {
      return import('@/views/Login.vue');
    },
    alias: ['/'],
    // https://medium.com/web-design-zone/vue-router-%E9%87%8D%E6%96%B0%E5%B0%8E%E5%90%91%E8%88%87%E5%88%A5%E5%90%8Dredirect-and-alias-462bccbcc244
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/login',
  //   name: '404',
  // },
  // 登入後各頁面
  // {
  //   path: '/page',
  //   name: 'page',
  //   component: () => {
  //     return import('../views/pages.vue');
  //   },
  //   children: [
  //     {
  //       path: '/index',
  //       name: 'index',
  //       component: () => { return import('../views/Home.vue'); },
  //     },
  //     {
  //       path: '/A_1',
  //       name: 'A_1',
  //       component: () => { return import('../views/A_0/A_1.vue'); },
  //     },
  //     {
  //       path: '/A_2',
  //       name: 'A_2',
  //       component: () => { return import('../views/A_0/A_2.vue'); },
  //     },
  //     {
  //       path: '/A_3',
  //       name: 'A_3',
  //       component: () => { return import('../views/A_0/A_3.vue'); },
  //     },
  //   ],
  // },
  // {
  //   // system admin
  //   path: '/system',
  //   name: 'system',
  //   component: system,
  //   children: [
  //     {
  //       path: '/system/As_1',
  //       name: 'As_1',
  //       component: () => { return import('../views/System/As_0/As_1.vue'); },
  //     },
  //   ],
  // },
  // // System Admin
  // // {
  // //   // system admin
  // //   path: '/sys',
  // //   name: 'sys',
  // //   component: () => {
  // //     return import('@/views/System/Admin.vue');
  // //   },
  // //   children: [],
  // // },
];

const CreateRouterfn = () => {
  return createRouter({
    history: createWebHistory(process.env.BASE_URL), // HTML5 (History API) 模式
    routes,
  });
};

const router = CreateRouterfn();

const indexRoute = {
  path: '/index',
  name: 'index',
  component: () => {
    return import('@/views/Home.vue');
  },
  children: [],
};

// ↓ BU page
const pagesRoute = {
  path: '/page',
  name: 'page',
  component: () => {
    return import('@/views/pages.vue');
  },
  children: [],
};

// ↓ Sys page
const systemRoute = {
  path: '/system',
  name: 'system',
  component: () => {
    return import('@/views/System/Admin.vue');
  },
  children: [],
};
const sysIndexRoute = {
  path: '/system/index',
  name: 'sysIndex',
  component: () => {
    return import('@/views/System/As_0/As_2.vue');
  },
  children: [],
};
// 把接到的資料組到 BU list & Sys list 裡面
function addRoute(route) {
  let child = {};
  // console.log(route);
  if (route.system && route.route && route.component) {
    child = {
      path: route.route,
      name: route.code,
      component: () => import(`@/${route.component}.vue`),
    };
    systemRoute.children.push(child);
    //
  } else if (!route.system && route.route && route.component) {
    child = {
      path: route.route,
      name: route.code,
      component: () => import(`@/${route.component}.vue`),
    };
    pagesRoute.children.push(child);
  }
  // router.addRoute(child);
}
//
function loopChild(route) {
  route.forEach((routeItem) => {
    if (routeItem.subitems && routeItem.subitems.length) {
      loopChild(routeItem.subitems);
    } else {
      addRoute(routeItem);
    }
  });
}

/**
 * 將選單列表加入router
 * @param {*} myRoute
 */
export const AddRuoteFn = (myRoute) => {
  loopChild(myRoute);
  // console.log(pagesRoute);
  pagesRoute.children.push(indexRoute);
  router.addRoute(pagesRoute);
  systemRoute.children.push(sysIndexRoute);
  router.addRoute(systemRoute);
  // export const AddRuoteFn = () => {
  router.addRoute({
    path: '/:pathMatch(.*)*',
    redirect: '/login',
    name: '404',
  });
};
//
export const resetRouter = () => {
  const newRouter = CreateRouterfn();
  router.matcher = newRouter.matcher;
  routeState.routeCreated = false;
};

//
// https://book.vue.tw/CH4/4-4-navigation-guards.html
// https://www.cnblogs.com/wanglei1900/p/16950047.html
// 「每一個」路由要進入之前，都會先經過這裡：
// https://blog.csdn.net/dazhongliu666/article/details/114657643
//
router.beforeEach((to, from, next) => {
  const token = JSON.parse(sessionStorage.getItem('token') || '{}');
  const nowShowing = sessionStorage.getItem('nowShowing');
  const hasToken = token && token.token;

  console.log('to.path =', to.path);
  console.log('to.query =', to.query);
  console.log('是否建立動態路由 :', routeState.routeCreated);
  console.log('nowShowing =', nowShowing);

  // ==========================
  // 1. 未登入 → 只能進 login
  // ==========================
  if (!hasToken) {
    if (to.path === '/login' || to.path === '/') {
      return next();
    }
    return next(`/login?redirect=${to.fullPath}`);
  }

  // ==========================
  // 2. 已登入但動態路由尚未建立 → 建立後直接放行
  // ==========================
  if (!routeState.routeCreated) {
    const menu = JSON.parse(sessionStorage.getItem('MainMenu') || '[]');
    AddRuoteFn(menu);
    routeState.routeCreated = true;
    console.log('建立好menu');

    return next({ ...to, replace: true });
  }

  // ==========================
  // 3. 動態路由已建立 → System / BU 權限判斷
  // ==========================
  if (nowShowing) {
    const ns = JSON.parse(nowShowing);

    // System 使用者 → 只能進 /system
    if (ns.re_name === 'System' && !to.path.startsWith('/system')) {
      return next('/system/index');
    }

    // BU 使用者 → 不能進 /system
    if (ns.re_name !== 'System' && to.path.startsWith('/system')) {
      return next('/index');
    }
  }

  // ==========================
  // 4. 預設放行
  // ==========================

  return next();
});

export default router;
